module.exports = "<div class=\"home-body\">\n  <div class=\"home-container\">\n    <img class=\"logo\" src=\"assets/img/homeLogo.png\" />\n    <div class=\"container-title\">\n      {{'home.title'|translate}}\n    </div>\n    <div class=\"container-description\">\n      {{'home.description'|translate}}\n    </div>\n    <button class=\"btn-enter-page\" (click)=\"enterPage()\">\n        {{'home.button.text'|translate}} \n    </button>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/home/home.component.html
// module id = ../../../../../src/app/components/home/home.component.html
// module chunks = main